import HeroIllustration from '@/components/illustrations/HeroIllustration'
import { runSubmit, type ToolRunBinding } from './tool-run'
// Generated from the reference HTML (tools/ai-citation-tracker.nogate.html). It may carry hand edits since (SEO, accessibility, server-rendered data): edit it directly, never regenerate over it.
import Link from 'next/link'
import type { CSSProperties, ReactNode } from 'react'
import RefScript from '@/components/shell/RefScript'

/** The reference page's own script, as written. */
const SCRIPT =
  "/* ---------- radar scope (canvas) ---------- */\n  const canvas = $('#scope'), ctx = canvas ? canvas.getContext('2d') : null;\n  if (canvas) {\n  const tags = $$('.scope__tag');\n  const degEl = $('#sweepDeg');\n  // blips: angle (deg), radius fraction, tag index\n  const blips = [\n    { a: 32,  r: .62, t: 0 }, // ChatGPT\n    { a: 118, r: .78, t: 1 }, // Claude\n    { a: 212, r: .50, t: 2 }, // Gemini\n    { a: 296, r: .70, t: 3 }, // Perplexity\n  ];\n  const ink = () => getComputedStyle(document.body).getPropertyValue('--ink').trim() || '#121212';\n  const accent = '#008dcc';\n  let W = 0, H = 0, dpr = 1, angle = 0, last = 0;\n  const resize = () => {\n    const rect = canvas.getBoundingClientRect();\n    dpr = Math.min(2, devicePixelRatio || 1);\n    W = Math.round(rect.width * dpr); H = Math.round(rect.height * dpr);\n    canvas.width = W; canvas.height = H;\n    // position tags\n    const R = rect.width / 2;\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = R + Math.cos(rad) * R * b.r, y = R + Math.sin(rad) * R * b.r;\n      const el = tags[b.t]; if (!el) return;\n      el.style.left = x + 'px'; el.style.top = (y - 22) + 'px';\n    });\n  };\n  new ResizeObserver(resize).observe(canvas); resize();\n\n  const draw = (t) => {\n    const dt = last ? Math.min(50, t - last) : 16; last = t;\n    if (!reduced()) angle = (angle + dt * 0.045) % 360;\n    const cx = W / 2, cy = H / 2, R = Math.min(cx, cy) - 2 * dpr;\n    ctx.clearRect(0, 0, W, H);\n    ctx.save(); ctx.translate(cx, cy);\n    const col = ink();\n    // rings\n    ctx.lineWidth = 1 * dpr; ctx.strokeStyle = col; ctx.globalAlpha = .22;\n    [1, .75, .5, .25].forEach(f => { ctx.beginPath(); ctx.arc(0, 0, R * f, 0, Math.PI * 2); ctx.stroke(); });\n    // crosshair + ticks\n    ctx.globalAlpha = .18;\n    ctx.beginPath(); ctx.moveTo(-R, 0); ctx.lineTo(R, 0); ctx.moveTo(0, -R); ctx.lineTo(0, R); ctx.stroke();\n    ctx.globalAlpha = .35;\n    for (let d = 0; d < 360; d += 10) {\n      const rad = d * Math.PI / 180, len = d % 30 === 0 ? 10 : 5;\n      ctx.beginPath();\n      ctx.moveTo(Math.cos(rad) * (R - len * dpr), Math.sin(rad) * (R - len * dpr));\n      ctx.lineTo(Math.cos(rad) * R, Math.sin(rad) * R); ctx.stroke();\n    }\n    // sweep trail (conic)\n    const a0 = (angle - 90) * Math.PI / 180;\n    const grad = ctx.createConicGradient ? ctx.createConicGradient(a0 - Math.PI * 0.55, 0, 0) : null;\n    ctx.globalAlpha = 1;\n    if (grad) {\n      grad.addColorStop(0, 'rgba(0,141,204,0)');\n      grad.addColorStop(0.55, 'rgba(0,141,204,.40)');\n      grad.addColorStop(0.5501, 'rgba(0,141,204,0)');\n      grad.addColorStop(1, 'rgba(0,141,204,0)');\n      ctx.fillStyle = grad;\n      ctx.beginPath(); ctx.arc(0, 0, R, 0, Math.PI * 2); ctx.fill();\n    }\n    // sweep arm\n    ctx.strokeStyle = accent; ctx.lineWidth = 2 * dpr; ctx.globalAlpha = 1;\n    ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(Math.cos(a0) * R, Math.sin(a0) * R); ctx.stroke();\n    // blips\n    blips.forEach(b => {\n      const rad = (b.a - 90) * Math.PI / 180;\n      const x = Math.cos(rad) * R * b.r, y = Math.sin(rad) * R * b.r;\n      // how recently the sweep passed: 0..1 (1 = just now)\n      let diff = (angle - b.a + 360) % 360; const heat = Math.max(0, 1 - diff / 110);\n      ctx.beginPath(); ctx.arc(x, y, 3.5 * dpr, 0, Math.PI * 2);\n      ctx.fillStyle = col; ctx.globalAlpha = .35 + heat * .65; ctx.fill();\n      if (heat > 0) {\n        ctx.beginPath(); ctx.arc(x, y, (6 + (1 - heat) * 26) * dpr, 0, Math.PI * 2);\n        ctx.strokeStyle = accent; ctx.lineWidth = 1.2 * dpr; ctx.globalAlpha = heat * .9; ctx.stroke();\n      }\n      const el = tags[b.t]; if (el) el.classList.toggle('is-hot', heat > 0.15);\n    });\n    // center\n    ctx.globalAlpha = 1; ctx.fillStyle = col;\n    ctx.beginPath(); ctx.arc(0, 0, 3 * dpr, 0, Math.PI * 2); ctx.fill();\n    ctx.restore();\n    if (degEl) degEl.textContent = String(Math.round(angle)).padStart(3, '0') + '\u00b0';\n    requestAnimationFrame(draw);\n  };\n  requestAnimationFrame(draw);\n  }\n\n  \n;\n\n(() => {\n  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('reduce-motion');\n\n  // ---- instrument: adds .on when visible (CSS primitives animate), counts [data-num], Replay re-runs\n  const inst = document.getElementById('inst');\n  if (inst) {\n    const nums = [...inst.querySelectorAll('[data-num]')];\n    const count = () => nums.forEach(el => {\n      const end = parseFloat(el.dataset.num), suf = el.dataset.suffix || '', dec = +(el.dataset.dec || 0), dur = reduced() ? 1 : 1100, t0 = performance.now();\n      const s = t => { const p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3); el.textContent = (end * k).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(s); };\n      requestAnimationFrame(s);\n    });\n    const run = () => { inst.classList.remove('on'); void inst.offsetWidth; requestAnimationFrame(() => { inst.classList.add('on'); count(); }); };\n    new IntersectionObserver((es, io) => es.forEach(e => { if (e.isIntersecting) { setTimeout(run, 250); io.disconnect(); } }), { threshold: .35 }).observe(inst);\n    const rp = document.getElementById('instReplay'); if (rp) rp.addEventListener('click', run);\n  }\n\n  // ---- embed tabs + copy (badge page)\n  const tabs = document.getElementById('embedTabs');\n  if (tabs) {\n    tabs.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; [...tabs.children].forEach(x => x.setAttribute('aria-selected', String(x === b))); document.querySelectorAll('.snip [role=\"tabpanel\"]').forEach(p => p.classList.toggle('is-on', p.dataset.panel === b.dataset.tab)); });\n    document.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', async () => { try { await navigator.clipboard.writeText(b.dataset.copy); } catch (_) {} b.classList.add('is-done'); const t = b.innerHTML; b.lastChild.textContent = 'Copied'; setTimeout(() => { b.classList.remove('is-done'); b.innerHTML = t; }, 1400); }));\n  }\n\n  // ---- sub nav scrollspy + dark/accent adaptation (same as the service pages)\n  const sub = document.getElementById('subnav'); if (!sub) return;\n  const links = [...sub.querySelectorAll('a')], targets = links.map(a => document.querySelector(a.getAttribute('href'))).filter(Boolean);\n  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(l => l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id)); }), { rootMargin: '-35% 0px -55% 0px' });\n  targets.forEach(t => io.observe(t));\n  const sheets = [...document.querySelectorAll('.sheet--ink, .sheet--accent')];\n  const last = document.getElementById(sub.dataset.last);\n  const band = () => {\n    const y = 72 + 26; let dark = false, accent = false;\n    for (const s of sheets) { const r = s.getBoundingClientRect(); if (r.top <= y && r.bottom > y) { accent = s.classList.contains('sheet--accent'); dark = !accent; break; } }\n    sub.classList.toggle('is-dark', dark); sub.classList.toggle('is-accent', accent);\n    if (last) sub.classList.toggle('is-gone', last.getBoundingClientRect().bottom < y);\n  };\n  addEventListener('scroll', band, { passive: true }); addEventListener('resize', band); band();\n})();\n"

export default function ToolAiCitationTrackerRef({
  run,
  form,
  output,
}: {
  run?: ToolRunBinding
  form?: ReactNode
  output?: ReactNode
}) {
  return (
    <>
      {' '}
      <div id='top'>
        {' '}
        <section
          className='sheet thero tpage'
          id='run'
          data-rail='Run'
          data-slot='hero'
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='hero__top'>
              {' '}
              <span className='eyebrow' data-slot='hero.eyebrow'>
                {'Tools / 05 · AI citations'}
              </span>{' '}
              <span className='mono' data-slot='hero.scope'>
                {'$5 one-time · 4 providers + Grok · report opens here'}
              </span>{' '}
            </div>{' '}
            <div className='thero__grid'>
              {' '}
              <div className='thero__copy'>
                {' '}
                <div className='thero__tags' data-slot='hero.tags'>
                  <span className='chip chip--paid'>{'Paid · $5'}</span>
                  <span className='chip'>{'AI citations'}</span>
                </div>{' '}
                <h1 className='h-display h1' id='heroTitle' data-slot='hero.h1'>
                  <span className='word'>
                    <span>Do</span>
                  </span>{' '}
                  <span className='word'>
                    <span>AI</span>
                  </span>{' '}
                  <span className='word'>
                    <span>search</span>
                  </span>{' '}
                  <span className='word'>
                    <span>engines</span>
                  </span>{' '}
                  <span className='word'>
                    <span>mention</span>
                  </span>{' '}
                  <span className='serif'>
                    <span className='word'>
                      <span>your</span>
                    </span>{' '}
                    <span className='word'>
                      <span>brand?</span>
                    </span>
                  </span>
                </h1>{' '}
                <p className='lede' data-reveal='' data-slot='hero.sub'>
                  {
                    'Check whether ChatGPT, Perplexity, Claude, and Gemini mention your brand in their responses. Test brand recognition, competitive visibility, and citation quality.'
                  }
                </p>{' '}
                <div data-reveal='fade'>
                  {form ?? (
                    <form
                      className='run'
                      id='runForm'
                      data-slot='hero.form'
                      noValidate
                      onSubmit={runSubmit(run)}
                    >
                      {' '}
                      <label className='run__field'>
                        <span>{'Website URL'}</span>
                        <input
                          type='text'
                          name='f0'
                          placeholder='Website URL (e.g. shopify.com)'
                          autoComplete='off'
                          inputMode='url'
                          value={run ? (run.values[0] ?? '') : undefined}
                          onChange={
                            run
                              ? e => run.onChange(0, e.target.value)
                              : undefined
                          }
                          onBlur={
                            run?.onBlur ? () => run.onBlur?.(0) : undefined
                          }
                          disabled={run?.loading}
                        />
                      </label>
                      <div className='run__row'>
                        <label className='run__field'>
                          <span>{'Brand'}</span>
                          <input
                            type='text'
                            name='f1'
                            placeholder='Brand (auto-detected from URL)'
                            autoComplete='off'
                            value={run ? (run.values[1] ?? '') : undefined}
                            onChange={
                              run
                                ? e => run.onChange(1, e.target.value)
                                : undefined
                            }
                            onBlur={
                              run?.onBlur ? () => run.onBlur?.(1) : undefined
                            }
                            disabled={run?.loading}
                          />
                        </label>
                        <label className='run__field'>
                          <span>{'Category'}</span>
                          <input
                            type='text'
                            name='f2'
                            placeholder='Category (auto-detected, edit if needed)'
                            autoComplete='off'
                            value={run ? (run.values[2] ?? '') : undefined}
                            onChange={
                              run
                                ? e => run.onChange(2, e.target.value)
                                : undefined
                            }
                            onBlur={
                              run?.onBlur ? () => run.onBlur?.(2) : undefined
                            }
                            disabled={run?.loading}
                          />
                        </label>
                      </div>{' '}
                      <div className='run__actions'>
                        <button
                          className='btn btn--accent'
                          type='submit'
                          disabled={run?.loading}
                        >
                          {'Check Citations'}
                          <svg
                            className='arrow'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='1.8'
                          >
                            <path d='M5 12h14M13 6l6 6-6 6' />
                          </svg>
                        </button>
                        <button
                          type='button'
                          className='btn btn--ghost btn--sm'
                          data-example='pixelmojo.io'
                          onClick={run?.onExample}
                        >
                          {'Try pixelmojo.io'}
                        </button>
                      </div>{' '}
                      <p className='run__note' data-slot='hero.note'>
                        <i />
                        <span>
                          {
                            'Pay a one-time $5 to run this check. Your report opens right here.'
                          }
                        </span>
                      </p>{' '}
                      {run?.error ? (
                        <p className='run__note run__error' role='alert'>
                          <i />
                          {run.error}
                        </p>
                      ) : null}
                    </form>
                  )}
                </div>{' '}
              </div>{' '}
              <aside
                className='inst inst--art'
                id='inst'
                data-reveal='fade'
                data-slot='hero.instrument'
                data-glyph='track'
              >
                {' '}
                <div className='inst__bar'>
                  <b>{'AI Citation Tracker'}</b>
                  <span className='inst__state'>
                    <i />
                    {'Preview'}
                  </span>
                </div>{' '}
                <div className='inst__canvas'>
                  <HeroIllustration variant='track'>
                    <text x='20' y='42' textAnchor='start' className='lab'>
                      {'CHATGPT'}
                    </text>
                    <rect
                      x='108'
                      y='33'
                      width='200'
                      height='10'
                      rx='5'
                      className='frame'
                    />
                    <rect
                      x='108'
                      y='33'
                      width='150'
                      height='10'
                      rx='5'
                      className='gb'
                      fill='var(--radar)'
                      style={{ '--i': '0' } as CSSProperties}
                    />
                    <text
                      x='318'
                      y='42'
                      textAnchor='start'
                      className='gf lab'
                      style={{ '--i': '2' } as CSSProperties}
                    >
                      {'PRIMARY'}
                    </text>
                    <text x='20' y='78' textAnchor='start' className='lab'>
                      {'PERPLEXITY'}
                    </text>
                    <rect
                      x='108'
                      y='69'
                      width='200'
                      height='10'
                      rx='5'
                      className='frame'
                    />
                    <rect
                      x='108'
                      y='69'
                      width='184'
                      height='10'
                      rx='5'
                      className='gb'
                      fill='var(--radar)'
                      style={{ '--i': '1' } as CSSProperties}
                    />
                    <text
                      x='318'
                      y='78'
                      textAnchor='start'
                      className='gf lab'
                      style={{ '--i': '3' } as CSSProperties}
                    >
                      {'URL'}
                    </text>
                    <text x='20' y='114' textAnchor='start' className='lab'>
                      {'CLAUDE'}
                    </text>
                    <rect
                      x='108'
                      y='105'
                      width='200'
                      height='10'
                      rx='5'
                      className='frame'
                    />
                    <rect
                      x='108'
                      y='105'
                      width='72'
                      height='10'
                      rx='5'
                      className='gb'
                      fill='var(--radar)'
                      style={{ '--i': '2' } as CSSProperties}
                    />
                    <text
                      x='318'
                      y='114'
                      textAnchor='start'
                      className='gf lab'
                      style={{ '--i': '4' } as CSSProperties}
                    >
                      {'LISTED'}
                    </text>
                    <text x='20' y='150' textAnchor='start' className='lab'>
                      {'GEMINI'}
                    </text>
                    <rect
                      x='108'
                      y='141'
                      width='200'
                      height='10'
                      rx='5'
                      className='frame'
                    />
                    <rect
                      x='108'
                      y='141'
                      width='118'
                      height='10'
                      rx='5'
                      className='gb'
                      fill='var(--radar)'
                      style={{ '--i': '3' } as CSSProperties}
                    />
                    <text
                      x='318'
                      y='150'
                      textAnchor='start'
                      className='gf lab'
                      style={{ '--i': '5' } as CSSProperties}
                    >
                      {'MENTIONED'}
                    </text>
                    <text x='20' y='186' textAnchor='start' className='lab'>
                      {'GROK'}
                    </text>
                    <rect
                      x='108'
                      y='177'
                      width='200'
                      height='10'
                      rx='5'
                      fill='none'
                      stroke='var(--line-strong)'
                      strokeDasharray='4 4'
                    />
                    <text x='318' y='186' textAnchor='start' className='lab'>
                      {'REPORT-ONLY'}
                    </text>
                    <text x='180' y='216' textAnchor='middle' className=''>
                      {'PROMINENCE · PRIMARY › MENTIONED › LISTED'}
                    </text>
                  </HeroIllustration>
                </div>{' '}
                <div className='inst__foot'>
                  <span data-slot='hero.inst_note'>
                    {'Illustrative · prominence per provider'}
                  </span>
                  <button
                    className='inst__replay'
                    type='button'
                    id='instReplay'
                  >
                    {'Replay '}
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M4 12a8 8 0 1 0 2.3-5.7M4 4v5h5' />
                    </svg>
                  </button>
                </div>{' '}
              </aside>{' '}
            </div>{' '}
          </div>{' '}
          {output ? (
            <div className='container tool-output'>{output}</div>
          ) : null}
        </section>{' '}
        <div className='subnav' id='subnav' data-last='related'>
          {' '}
          <div className='container subnav__inner'>
            {' '}
            <a href='#about'>
              <i />
              {'What it does'}
            </a>
            <a href='#checks'>
              <i />
              {'What the AI Citation Tracker checks'}
            </a>
            <a href='#scoring'>
              <i />
              {'Scoring'}
            </a>
            <a href='#research'>
              <i />
              {'Research'}
            </a>
            <a href='#related'>
              <i />
              {'Related tools'}
            </a>{' '}
            <span className='subnav__spacer' />{' '}
            <span className='mono'>
              {'$5 one-time · 4 providers + Grok · report opens here'}
            </span>{' '}
          </div>{' '}
        </div>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='about'
          data-rail='What it does'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'01 / What it does'}</span>{' '}
              <h2 className='h-display h2' data-slot='kicker'>
                {'A mention builds awareness. A URL '}
                <span className='serif'>{'drives traffic.'}</span>
              </h2>{' '}
            </div>{' '}
            <div className='about'>
              {' '}
              <div className='about__copy' data-reveal='' data-slot='intro'>
                <p className='lede'>
                  {
                    'AI citation tracking measures whether AI search engines mention or link to your brand when users ask relevant questions. Unlike traditional SEO rankings, AI citations are dynamic: the same query can produce different results each time, and each AI provider (ChatGPT, Perplexity, Claude, Gemini) uses different training data and retrieval methods.'
                  }
                </p>
                <p>
                  {
                    'Tracking citations across all four providers reveals where your brand has recognition, where competitors are being cited instead, and whether AI engines link to your actual URLs or just mention your name. This distinction matters because URL citations drive direct traffic while brand mentions build awareness.'
                  }
                </p>
              </div>{' '}
              <div
                className='facts facts--tool'
                data-reveal='fade'
                data-slot='facts'
              >
                <div className='fact'>
                  <span>{'Input'}</span>
                  <b>{'Website URL, brand, category'}</b>
                </div>
                <div className='fact'>
                  <span>{'Output'}</span>
                  <b>{'0-100 score, 8 query types, per-provider mentions'}</b>
                </div>
                <div className='fact'>
                  <span>{'Price'}</span>
                  <b>{'$5 one-time · no subscription'}</b>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='checks'
          data-rail='What the AI Citation Tracker checks'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>
                  {'02 / What the AI Citation Tracker checks'}
                </span>
                <h2 className='h-display h2' data-slot='checks.title'>
                  {'What the AI Citation Tracker '}
                  <span className='serif'>{'checks.'}</span>
                </h2>
              </div>{' '}
              <p className='lede'>
                {
                  '4 checks, each with a plain-English reason it matters. Every one maps to a line in the report.'
                }
              </p>{' '}
            </div>{' '}
            <div
              className='wgrid reveal-stagger'
              data-reveal=''
              data-slot='checks.items'
              data-n='4'
            >
              <div className='wcard'>
                <span className='mono'>
                  <span>{'01'}</span>
                  <span>{'AI Citation Tracker'}</span>
                </span>
                <h3>{'4 AI Providers + Grok'}</h3>
                <p>
                  {
                    'ChatGPT (GPT-4o-mini), Perplexity (Sonar), Claude (Haiku), and Gemini (Flash) tested simultaneously, plus xAI Grok shown report-only (mentions only, never scored).'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'02'}</span>
                  <span>{'AI Citation Tracker'}</span>
                </span>
                <h3>{'8 Query Types'}</h3>
                <p>
                  {
                    'Brand awareness, 5 competitive queries, and reputation analysis tailored to your business category.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'03'}</span>
                  <span>{'AI Citation Tracker'}</span>
                </span>
                <h3>{'URL Citations'}</h3>
                <p>
                  {
                    'Perplexity is the only provider that returns source URLs. We check if your domain appears in its citations.'
                  }
                </p>
              </div>
              <div className='wcard'>
                <span className='mono'>
                  <span>{'04'}</span>
                  <span>{'AI Citation Tracker'}</span>
                </span>
                <h3>{'Sentiment & Prominence'}</h3>
                <p>
                  {
                    'Not just mentioned/not mentioned. We analyze how prominently and positively your brand appears.'
                  }
                </p>
              </div>
              <div className='wcard wcard--fill' aria-hidden='true'>
                <b>{'4'}</b>
                <span>{'checks in every report'}</span>
              </div>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='scoring'
          data-rail='Scoring'
          style={
            {
              borderRadius: 'var(--radius-sheet) var(--radius-sheet) 0 0',
              marginTop: 'calc(var(--radius-sheet) * -1)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='sec-head' data-reveal=''>
              {' '}
              <span className='eyebrow'>{'03 / Scoring'}</span>{' '}
              <h2 className='h-display h2' data-slot='scoring.title'>
                {'How We Score '}
                <span className='serif'>{'(And Why It Matters)'}</span>
              </h2>{' '}
            </div>{' '}
            <div className='score'>
              {' '}
              <div className='score__label' data-reveal=''>
                {' '}
                <div className='score__total'>
                  <span data-count='100'>{'100'}</span>
                  <small>{'points'}</small>
                </div>{' '}
                <p data-slot='scoring.intro'>
                  {
                    'Most citation trackers are paid SaaS tools starting at $50-500/month. Radar runs the same multi-provider check for a one-time $5, so you can see your baseline without a subscription.'
                  }
                </p>{' '}
              </div>{' '}
              <div
                className='srows'
                data-reveal='fade'
                data-slot='scoring.items'
              >
                <div className='srow'>
                  <span className='srow__i'>{'01'}</span>
                  <div>
                    <div className='srow__n'>{'Brand Recognition'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '25%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'Do AI systems actually know your brand? We ask about your company and filter out shallow name-echoes. Only substantive, detailed responses count as real recognition.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='25'>{'25'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'02'}</span>
                  <div>
                    <div className='srow__n'>{'Competitive Visibility'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '35%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'The highest-weighted category with 5 different competitive queries. When someone asks for recommendations in your category, does your brand appear organically? Weighted by prominence (primary > mentioned > listed).'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='35'>{'35'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'03'}</span>
                  <div>
                    <div className='srow__n'>{'URL Citations'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '20%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'Perplexity is the only AI that returns source URLs via API. We check if your domain appears in its citation list. This is the strongest signal of real AI discoverability.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='20'>{'20'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
                <div className='srow'>
                  <span className='srow__i'>{'04'}</span>
                  <div>
                    <div className='srow__n'>{'Sentiment & Consistency'}</div>
                    <div className='srow__bar'>
                      <i style={{ '--w': '20%' } as CSSProperties} />
                    </div>
                    <p className='srow__d'>
                      {
                        'Are mentions positive or neutral? And are you cited consistently across providers, or only by one? Multi-provider consistency signals genuine authority.'
                      }
                    </p>
                  </div>
                  <div className='srow__p'>
                    <span data-count='20'>{'20'}</span>
                    <small>{'pts'}</small>
                  </div>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--pad'
          id='research'
          data-rail='Research'
          style={
            {
              '--bg': 'var(--paper-2)',
              paddingBottom: 'var(--section)',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container'>
            {' '}
            <div className='research'>
              {' '}
              <div
                className='research__copy'
                data-reveal=''
                data-slot='research.copy'
              >
                {' '}
                <span className='eyebrow'>{'04 / Research'}</span>{' '}
                <h2
                  className='h-display h3'
                  style={
                    { fontSize: 'clamp(30px,3.6vw,52px)' } as CSSProperties
                  }
                >
                  {'Built on our own research'}
                </h2>{' '}
                <p>
                  {
                    'This tool reflects what we learned tracking our own AI citation presence across ChatGPT, Perplexity, Claude, and Gemini. The scoring criteria come from real optimization experiments.'
                  }
                </p>{' '}
              </div>{' '}
              <div data-reveal='fade'>
                <div className='reading' data-slot='research.links'>
                  <Link href='/blogs/how-to-track-ai-citations-chatgpt-perplexity-claude-gemini'>
                    <span className='mono'>{'Guide'}</span>
                    <b>{'How to Track AI Citations: A Practical Guide'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/build-brand-ai-search-engines-cite'>
                    <span className='mono'>{'Brand'}</span>
                    <b>{'How to Build a Brand That AI Search Engines Cite'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/geo-playbook-get-cited-chatgpt-perplexity-claude'>
                    <span className='mono'>{'GEO'}</span>
                    <b>{'The GEO Playbook'}</b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/optimized-ai-search-pixelmojo-results'>
                    <span className='mono'>{'Dated note'}</span>
                    <b>
                      {
                        'What We Changed for AI Search by February 2026 (Dated Note)'
                      }
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                  <Link href='/blogs/seo-vs-geo-vs-aeo-guide-2026'>
                    <span className='mono'>{'Strategy'}</span>
                    <b>
                      {
                        'SEO vs AEO vs GEO: From Ranking in Search to Becoming the Recommended Brand'
                      }
                    </b>
                    <i>
                      <svg
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2'
                      >
                        <path d='M7 17L17 7M8 7h9v9' />
                      </svg>
                    </i>
                  </Link>
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage'
          id='related'
          data-rail='Related tools'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container rel'>
            {' '}
            <div className='sec-head sec-head--split' data-reveal=''>
              {' '}
              <div style={{ display: 'grid', gap: '22px' } as CSSProperties}>
                <span className='eyebrow'>{'05 / Related free tools'}</span>
                <h2 className='h-display h2' data-slot='related.title'>
                  {'Related free '}
                  <span className='serif'>{'tools.'}</span>
                </h2>
              </div>{' '}
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </Link>{' '}
            </div>{' '}
            <div
              className='tgrid reveal-stagger'
              data-reveal=''
              data-slot='related.items'
              data-n='4'
            >
              <Link className='tcard' href='/tools/answer-engine-tester'>
                <div className='tcard__top'>
                  <span>{'Per question'}</span>
                </div>
                <h3>{'Answer Engine Citation Tester'}</h3>
                <p>
                  {
                    'Test whether four AI engines cite your page for a question.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/brand-disambiguation'>
                <div className='tcard__top'>
                  <span>{'Entity'}</span>
                </div>
                <h3>{'Brand Disambiguation Check'}</h3>
                <p>
                  {
                    'See whether AI engines confuse your brand with a same-named entity.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/reddit-brand-monitor'>
                <div className='tcard__top'>
                  <span>{'LLM detection'}</span>
                </div>
                <h3>{'Reddit Brand Monitor'}</h3>
                <p>
                  {
                    'Find what people say about your brand on Reddit and spot seeded posts.'
                  }
                </p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
              <Link className='tcard' href='/tools/ai-readiness-score'>
                <div className='tcard__top'>
                  <span>{'Unified'}</span>
                </div>
                <h3>{'AI Readiness Score'}</h3>
                <p>{'See your overall AI-search readiness in one score.'}</p>
                <div className='tcard__foot'>
                  <span className='tcard__cat'>{'Tool'}</span>
                  <span className='tcard__go'>
                    <svg
                      viewBox='0 0 24 24'
                      fill='none'
                      stroke='currentColor'
                      strokeWidth='2'
                    >
                      <path d='M7 17L17 7M8 7h9v9' />
                    </svg>
                  </span>
                </div>
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--ink sheet--pad'
          id='radar'
          data-rail='Radar'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='container radarband'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Radar'}</span>{' '}
              <h2 className='h-display h2'>
                {'Want the full picture across four '}
                <span className='serif'>{'AI engines?'}</span>
              </h2>{' '}
              <p className='lede'>
                {
                  'Radar orchestrates 13 AI visibility audits in staged batches: crawl access, llms.txt, structured data, brand citations, and more. It then surfaces cross-tool conflicts and ships a prioritized action plan for your domain.'
                }
              </p>{' '}
              <div className='hero__cta'>
                {' '}
                <Link className='btn btn--accent' href='/platform#free-audit'>
                  {'Get My Free Snapshot '}
                  <svg
                    className='arrow'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1.8'
                  >
                    <path d='M5 12h14M13 6l6 6-6 6' />
                  </svg>
                </Link>{' '}
                <Link
                  className='btn btn--ghost'
                  href='/services/ai-visibility-strategy'
                >
                  {'Or book a strategy session'}
                </Link>{' '}
              </div>{' '}
            </div>{' '}
            <div
              className='scope'
              data-reveal='fade'
              aria-label='Radar sweep across four AI engines'
            >
              {' '}
              <canvas id='scope' />{' '}
              <div className='scope__tags' aria-hidden='true'>
                {' '}
                <span className='scope__tag' data-tag='0'>
                  {'ChatGPT'}
                </span>
                <span className='scope__tag' data-tag='1'>
                  {'Claude'}
                </span>
                <span className='scope__tag' data-tag='2'>
                  {'Gemini'}
                </span>
                <span className='scope__tag' data-tag='3'>
                  {'Perplexity'}
                </span>{' '}
              </div>{' '}
              <div className='scope__meta'>
                {'Sweep · '}
                <b id='sweepDeg'>{'000°'}</b>
                {' · 13 checks · one pass'}
              </div>{' '}
            </div>{' '}
          </div>{' '}
        </section>{' '}
        <section
          className='sheet tpage sheet--accent cta sheet--pad'
          id='start'
          data-rail='Start'
          style={
            {
              paddingBottom: 'calc(var(--section) + var(--radius-sheet))',
              scrollMarginTop: '80px',
            } as CSSProperties
          }
        >
          {' '}
          <div className='cta__ghost' aria-hidden='true'>
            {'$5'}
          </div>{' '}
          <div className='container cta__inner'>
            {' '}
            <div
              data-reveal=''
              style={{ display: 'grid', gap: '22px' } as CSSProperties}
            >
              {' '}
              <span className='eyebrow'>{'Start now'}</span>{' '}
              <h2 className='h-display' data-slot='cta.title'>
                {'Run it on your brand. See what AI '}
                <span className='serif'>{'can read.'}</span>
              </h2>{' '}
              <p
                className='lede'
                style={{ color: 'rgba(18,18,18,.72)' } as CSSProperties}
                data-slot='cta.text'
              >
                {
                  'One-time $5, no subscription, report on this page. When you want the whole picture, Radar runs all 13 audits in one pass.'
                }
              </p>{' '}
            </div>{' '}
            <div className='hero__cta' data-reveal='fade'>
              <a className='btn' href='#run'>
                {'Check Citations'}
                <svg
                  className='arrow'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='1.8'
                >
                  <path d='M5 12h14M13 6l6 6-6 6' />
                </svg>
              </a>
              <Link className='btn btn--ghost' href='/tools'>
                {'Browse all tools'}
              </Link>
            </div>{' '}
          </div>{' '}
        </section>{' '}
      </div>{' '}
      <RefScript code={SCRIPT} />
    </>
  )
}
